<template>
    <div class="container">
        <div class="backroute" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/muro/${route.params.contentId}`)"><i class="material-icons">keyboard_arrow_left</i><span>{{ $t('muroUserHistory.BACK') }}</span></div>
        
        <template
        v-if="dataLoaded && userData.headers.length > 0"
        >
            <div class="history__status">
              <h3>{{ $t('muroUserHistory.DELIVERY_DETAIL') }}</h3>
              <!-- <span>ESTADO DE LA ACTIVIDAD: <strong :class="{'open': userData.activityStatus === 'Abierta'}">{{userData.activityStatus}}</strong></span> -->
            </div>
            <div class="user-info tutor__infoCard">
                <span class="user-info__name"><strong>{{ $t('global.PARTICIPANT') }}: </strong>{{userData.userInfo.firstName}} {{userData.userInfo.lastName}}</span>
                 <div class="user-info__status">
                    <strong>{{ $t('global.STATE') }}:</strong>
                    <span :class="{'NotFinished--a': userData.userInfo.status == 'NotFinished', 'FinishedOutOfTime--a': userData.userInfo.status === 'FinishedOutOfTime', 'FinishedInTime--a': userData.userInfo.status === 'FinishedInTime'}">
                        {{$t(`tutor.detail.status.${userData.userInfo.status}`)}}
                    </span>
                    <span v-if="userData.userInfo.status == 'NotFinished'">
                        {{userData.userInfo.timeDiffValue ? $t('global.EXPIRES_IN') + userData.userInfo.timeDiffValue + ' ' + $t(`date.params.${userData.userInfo.timeDiffParam}`) : $t('global.EXPIRED')}}
                    </span>
                    <span v-if="userData.userInfo.status == 'FinishedOutOfTime'">
                        {{userData.userInfo.timeDiffValue + ' ' + $t(`date.params.${userData.userInfo.timeDiffParam}`) + + ' ' + $t('global.LATE')}}
                    </span>
                </div>  

                <span class="user-info__mail" ><strong>{{$t('global.EMAIL')}}: </strong>{{userData.userInfo.email}}</span>
                <div><span><strong>{{ $t('global.LAST_MODIFICATION') }}: </strong></span><span>{{userData.userInfo.lastSeen ? formatDate(userData.userInfo.lastSeen) : $t('global.NEVER')}}</span></div>
            </div>

            <h3>Historial de entregas</h3>


            <div class="module_muro_container"
              v-dragscroll:nochilddrag="!isMobile"
            >

              <div class="module_muro"
                v-dragscroll:nochilddrag="!isMobile"
                >
                <div data-dragscroll
                v-for="(header, idx) in userData.headers"
                :key="idx" class="module_muro__column">
                      <h2 class="module_muro__header" data-dragscroll>{{ header.subject }}</h2>
                  </div>
              </div>


              <div 
              class="module_muro"
              v-dragscroll:nochilddrag="!isMobile"
              >

                  <!-- COLUMNAS -->
                  <div data-dragscroll
                  v-for="(header, idx) in userData.headers"
                      :key="idx" 
                      class="module_muro__column"
                  >
                      <!-- <h2 class="module_muro__header" data-dragscroll>{{ header.subject }}</h2> -->

                      
                      <!-- COMENTARIOS -->
                      <div v-for="(comment, idxComment) in header.comments" :key="idxComment">
                      <div class="module_muro__comment">
                          <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; ">
                          <span class="module_muro__name">
                              <strong>{{ userData.userInfo.firstName }} {{ userData.userInfo.lastName }}</strong>
                              {{ formatDate(comment.createdDate) }}
                          </span>              
                          </div>

                          <link-preview
                            :editMode="false"
                            :data="comment.link[0]"
                          />
                          <p class="module_muro__content" v-html="comment.comment"></p>


                      </div>
              

                      
                      </div>

                  </div>
              
              </div>

            </div>
      
        </template>

        <!-- if data is empty emptystate -->
        

        <div
        v-else-if="dataLoaded && userData.headers.length === 0">
          <EmptyState
            icon="event_note"
            :title="$t('muroUserHistory.NO_COMMENTS')"
            :message="$t('muroUserHistory.USER_HAS_NOT_POSTED_COMMENTS')"
          />
        </div>
        

        <div v-else>{{ $t('muroUserHistory.LOADING_INFORMATION') }}</div>


        


    </div>

    
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, inject, onUpdated, computed, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { Quill } from "vue3-editor";
import Emoji from "quill-emoji/dist/quill-emoji";
import EmptyState from '@/components/EmptyState.vue';
import { dragscroll } from 'vue-dragscroll';
import LinkPreview from '@/components/LinkPreview.vue';
import { useI18n } from 'vue-i18n';


Quill.register("modules/emoji", Emoji);


export default {
    directives: {
    dragscroll,
  },
    setup() {
      const { t } = useI18n();

        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const formatDate = inject("formatDate");
        const getFile = inject("getFile");
        const user = computed(() => store.getters.manageUser_user);
        const userData = ref();
        const lastSubmission = ref(null);
        const dataLoaded = ref(false);
        const submitMessageLoaded = ref(true)
        const isMobile = ref(window.innerWidth <= 1000)
        


        // const feedbackModel = ref({
        //     contentId: route.params.contentId,
        //     learningUsers: [route.params.userId],
        //     message: ""
        // });


        async function getUserData(message) {
            if (!message)
                dataLoaded.value = false;
            try {
                let req = await store.dispatch("muro_UserHistory", { contentId: route.params.contentId, userId: route.params.userId });
                userData.value = req.data;
                dataLoaded.value = true;
                // userData.value.activityStatus = userData.value.userInfo.status === 'FinishedOutOfTime' || (userData.value.userInfo.status === 'NotFinished' && !userData.value.userInfo.timeDiffValue ) ? 'Vencida' : 'Abierta'
                // Array.isArray(userData.value.submissions) ? lastSubmission.value = userData.value.submission[userData.value.submission.length - 1] : lastSubmission.value = [];
            }
            catch (error) {
                console.log(error);
            }
        }
        // const onSubmit = async () => {
        //     if (feedbackModel.value.message.trim().length < 1) {
        //         feedbackModel.value.message = "";
        //         return;
        //     }
        //     else {
        //         submitMessageLoaded.value = false
        //         await store.dispatch("activities_attachPostFeedback", feedbackModel.value);
        //         getUserData(true);
        //         feedbackModel.value.message = "";
        //         submitMessageLoaded.value = true
        //     }
        // };
        onMounted(() => {
            if (!user.value.permissions.includes('CURSO_ACTIVIDAD_DETALLE')) return
            getUserData();

            window.addEventListener('resize', () => isMobile.value = window.innerWidth <= 1000)

        });
        onUpdated(() => {
            // Setea el scroll hacia abajo para que aparezca el ultimo mensaje enviado.
            let messageBox = document.getElementById("messageBox");
            if (messageBox)
                messageBox.scrollTop = messageBox.scrollHeight;
        });

        onUnmounted(() => {
            window.removeEventListener('resize', () => isMobile.value = window.innerWidth <= 1000)
        })

        return {
            route,
            router,
            formatDate,
            isMobile,
            getFile,
            userData,
            lastSubmission,
            dataLoaded,
            submitMessageLoaded,
            user,
            t,
            customToolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }, { color: [] }, { background: [] },],
            ["emoji"]
            ],
            editorSettings: {
                modules: {
                "emoji-toolbar": true,
                "emoji-textarea": false,
                "emoji-shortname": false,
                },
            }
        };
    },
    components: {
      EmptyState,
      LinkPreview
     }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';



.module{
  &_muro_container {
    overflow: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background: map-get($dark, 400);
      position: absolute;
      border: 4px solid rgba(0, 0, 0, 0);
    }
    .module_muro:nth-child(1) {
      height: fit-content;
      .module_muro__column {
          height: auto;
      }
      .module_muro__header {
        display: flex;
        flex-direction: column;
        justify-content: center;height: 100%;
      }
    }
  }
  &_muro{
    // display: grid;
    // column-gap: 18px;
    overflow: visible;
    padding-bottom: 6px;
    height: 70vh;
    margin-top: 18px;

    display: flex;
    gap: 18px;
    .dropdown{
    width: fit-content;


    &__face{
        padding: 0;
        border-radius:0;
        border: none;
        width: fit-content
    }
    &__items{
        top: 0;
        left: 100%;
        flex-direction: row;
        width: 0;
        padding:0;
        visibility: hidden;
        li{
            font-size: 17px;
        }
    }
    input {
        display: none;
        &:checked ~ .dropdown__items {
        top: calc(100% + -28px);
        visibility: visible;
        left: -420%;
        padding: 10px;
        width: fit-content;
        opacity: 1;
        }
      }
    }
    &::-webkit-scrollbar-track {
      border-radius: 100px;
      background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100px;
      background: map-get($dark, 400);
      position: absolute;
      border: 4px solid rgba(0, 0, 0, 0);
    }
    &__fetchMoreComments{
      font-weight: 600;
      font-size: 18px;
      margin: 12px 0;
      color: $green;
    }
    &__button{
      font-size: 16px;
      font-weight: 600;
      outline: none;
      padding: 12px 0;
      &--cancel{
        @extend .module_muro__button;
        color: $green;
      }
      &--submit{
        @extend .module_muro__button;
        background-color: $green;
        color: #fff;
        width: 165px;
        border-radius: 44px;
      }
    }
    .quillWrapper{
      .ql-toolbar{
        background-color: #fff;
      }
      .ql-container{
        background-color: #fff;
        height: fit-content;
      }
    }
    &__title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 12px 0;
      @media (max-width: 700px){
        flex-direction: column;
      }
      &-activity{
        font-size: 22px;
        font-weight: 700;
      }
      &-date{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        gap: 6px;
        .material-icons-outlined{
          font-size: 18px;
        }
      }
    }
    &__column{
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 100%;
      min-width: 280px;
      max-height: 70vh;
      padding-top: 12px;
      padding-right: 4px;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;

      @media (min-height: 800px){
        max-height: 77vh;
      }
      &::-webkit-scrollbar-track {
        border-radius: 100px;
        background-color: rgba(0,0,0,.1);
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background: map-get($dark, 400);
        position: absolute;
        border: 4px solid rgba(0, 0, 0, 0);
      }
    }
    &__header{
      color: $green;
      font-size: 16px;
      font-weight: 700;
      width: 100%;
      padding: 12px 0;
      border: 2px solid $green;
      border-radius: 10px;
      text-align: center;
    }
    &__addComment{
      display: flex;
      align-items: center;
      gap: 6px;
      color: $green;
      font-size: 16px;
      font-weight: 600;
      align-self: center;
      .material-icons{
        font-size: 18px;
      }
    }
    &__comment{
      padding: 18px 16px;
      border-radius: 10px;
      background-color: #f6f6f6;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    &__name{
      font-size: 14px;
      font-weight: 400;
      color: #7D7D7D;
      strong{
        font-weight: 600;
        color: $green;
      }
    }
    &__image{
      width: 100%;
      max-height: 285px;
    }
    &__content{
      font-weight: 400;
      font-size: 18px;
      img{
        max-width: 100%;
        border-radius: 10px;
      }
      &--deleted{
        font-weight: 400;
        font-size: 13px;
        color: #7D7D7D;
        //text-align: center;
      }
    }
    &__buttons{
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 12px 0;
      padding-left: 12px;
      &:disabled{
        cursor: pointer;
        opacity: .6;
      }
      &--active{
        font-weight: 600;
        font-size: 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: $green !important;
        .material-icons-outlined{
          font-size: 16px;
          color: $green;
        }
      }
      button{
        font-weight: 600;
        font-size: 10px;
        display: flex;
        align-items: center;
        gap: 4px;
        color: #000;
        .material-icons-outlined{
          font-size: 16px;
        }
      }
    }
    &__childrenComment{
      width: 100%;
      display: flex;
      align-items: flex-start;
      position: relative;
      &_lines{
        height: 100%;
        width: 15%;
        padding-left: 12px;
      }
      &_line1{
        width: calc(15% - 12px);
        height: 50%;
        position: absolute;
        border-bottom: 1px solid #D2D2D2;
        border-left: 1px solid #D2D2D2;
      }
      &_line2{
        width: calc(15% - 12px);
        height: 100%;
        position: absolute;
        border-left: 1px solid #D2D2D2;
      }
      &_container{
        width: 85%;
        background-color: #F6F6F6;
        padding: 12px 18px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      &_name{
        font-size: 14px;
        font-weight: 400;
        color: #7D7D7D;
        strong{
          font-weight: 600;
          color: $green;
        }
      }
      &_content{
        font-size: 16px;
        font-weight: 400;
        img{
          max-width: 100%;
        }
      }
    }
  }
}

h3{
    font-weight: 600;
    font-size: 18px;
    color: $black;
    margin: 12px 0;
    @media screen and (max-width: $bpSmall){
        font-size: 16px;
    }
}

.backroute{
    margin-bottom: 24px;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2px;
    color: $green;
    font-size: 13px; 
    font-weight: 600;
    cursor: pointer;
    .material-icons{
        font-size: 18px;
    }
}

.user-info{
    width: 100%;
    padding: 16px;
    margin-bottom: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
    background: #fff;
    border-radius: 8px;
    color: $black;
    font-size: 14px;
    font-weight: 400;
    @media screen and (max-width: $bpBig){
        align-items: flex-start;
    }
    &__name{
        width: 50%;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
    }
    &__mail{
        width: 50%;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
    }
    &__attaches{
        width: 100%;
        display: flex;
        align-items: center;
        gap: 6px;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
        .files{
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
            color: $green;
            gap: 12px;
            @media screen and (max-width: $bpMedium) {
                font-size: 12px;
            }
            a{
                display: flex;
                align-items: center;
            }
            .material-icons{
                font-size: 17px;
            }
        }
    }
}

.submissions,.last-submission{
    width: 100%;
    margin-bottom: 32px;
    @include flex-column;
    align-items: flex-start;
    gap: 24px;
    h3{
        width: 100%;
        color: $green;
    }
    >div{
        width: 100%;
        //border-bottom: 1px solid $black;
        max-height: 300px;
        overflow-y: auto;
        &:last-child{
            border: none;
        }
    }
    .files{
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        a{
            padding: 7px 14px;
            display: flex;
            align-items: center;
            background: $green;
            color: #fff;
            border-radius: 16px;
            i{
                font-size: 17px;
            }
            span{
                text-decoration: underline;
                font-size: 14px;
            }
        }
    }
}

.history__status{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    color: $black;
    span{
        font-weight: 600;
        @media screen and (max-width: $bpSmall){
            font-size: 16px;
            text-align: center;
        }
        strong{
            margin-left: 8px;
            font-weight: 400;
            color: $red;
        }
        .open{
            color: $green;
        }
    }
}

.user-info__status{
    display: flex;
    align-items: center;
    gap: 6px;
    span:last-child{
        font-weight: 400;
        font-size: 12px;
        color: $darkgray;   
    }
}

.history__container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    width: calc(100%-24px);
    margin: 24px;
    @media screen and (max-width: $bpBig){
        margin: 12px;
    }
    .history__component{
        padding: 10px 24px 10px;
        background-color: $lightgray;
        border-radius: 10px;
        width: 40%;
        color: $black;
        @media screen and (max-width: $bpBig){
            width: 100%;
        }
    }
    .history__autor{
        font-weight: 600;
        font-size: 13px;
        color: $green;
    }
    .history__submission{
        font-weight: 400;
        margin-top: 4px;
        font-size: 13px;
    }
    .history__date{
        font-weight: 500;
        font-size: 11px;
        color: $darkgray;
        margin-left: 6px;
    }
    .history__newAttach{
        background-color: $lightgray;
        color: $black;
        margin: -10px -24px -10px;
        padding: 10px 24px 10px;
        border-radius: 10px;
        font-weight: 500;
        font-size: 12.5px;
        strong{
            color: $green;
        }
        .history__date{
            font-weight: 400;
        }
        .history__attach{
            display: flex;
            align-items: center;
            .files{
                gap: 0;
                font-weight: 600;   
                display: flex;
                flex-direction: column;
                padding: 0;
                margin-top: 6px;
                span{
                    font-size: 12px;
                }
                a{
                    color: $black;
                    padding:0;
                    background-color: inherit;
                }
            }
        }
    }
}

.history__form{
    border: none;
    width: 100%;
    padding: 12px 17px;
    display: flex; 
    justify-contenT: space-between;
    textarea{
        border: none;
        outline: none;
    }
    .history__text{
        border: none;
        width: 80%;
        margin-left: 14px;
        resize: none;
        height: 70px;
        outline: none;
    }
    .history__sendBtn{
        background: #009696;
        color: #fff;
        padding: 8px 16px;
        border-radius: 44px;
        font-weight: 600;
    }
}

.history__notContent{
    margin: 21px;
    display: flex;
    justify-content: center;
    font-weight: 400;
    opacity: 0.7;
}

.new-feedback{
    width: 100%;
    //max-width: 450px;
    h4{
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        font-weight: 500;
        .material-icons{
            font-size: 18px;
        }
    }
    textarea{
        width: 100%;
        height: 80px;
        padding: 6px;
        resize: none;
        border-radius: 4px;
    }
    &__actions{
        padding: 0;
        padding-top: 16px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        button{
            padding: 12px 28px;
            border-radius: 44px;
            color: $green;
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 6px;
            .material-icons-outlined{
                font-size: 14px;
            }
            &.confirm{
                background: $green;
                color: #fff;
            }
        }
        }
    }

.last-submission{
    >div{
        >div{
            height: fit-content;
            padding: 16px 0;
            display: flex;
            align-items: center;
            >span,div{
                padding: 0 24px;
            }
            span:first-child{
                //padding: 12px;
                font-weight: 600;
            }
        }
    }
    .feedback{
        display: flex;
        align-items: center;
        text-align: justify;
        .material-icons{
            margin-left: 8px;
            padding: 8px;
            font-size: 30px;
            border-radius: 10px;
            box-shadow: 0px 0px 8px -4px rgba(125,125,125,0.6);
            cursor: pointer;
        }
    }
}

@media screen and (max-width: $bpBig){
    .user-info{
        flex-direction: column;
        font-size: 11px;
    }

    .last-submission > div > div{
        flex-direction: column;
        gap: 10px;
        overflow-y: auto;
        span{
            align-self: flex-start
        }
    }
}
</style>